import VendorBilledHtml from './templates/vendor-billed.html';

export function VendorBilled () {
  return {
    controller: 'VendorBilledCtrl',
    restrict: 'E',
    templateUrl: VendorBilledHtml,
    scope: {
      vendor: '=',
      vendors: '='
    }
  }
}
